import InfluencerIdentityRowAvatar, { IInfluencerIdentityRowAvatarProps } from './Avatar'

export { IInfluencerIdentityRowAvatarProps }
export default InfluencerIdentityRowAvatar
